import { render, staticRenderFns } from "./StatisticData.vue?vue&type=template&id=35763f6d"
import script from "./StatisticData.vue?vue&type=script&lang=js"
export * from "./StatisticData.vue?vue&type=script&lang=js"
import style0 from "./StatisticData.vue?vue&type=style&index=0&id=35763f6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports